// extracted by mini-css-extract-plugin
export default {"page":"lY-z","cartModal":"mY-z","checkout":"nY-z","placeholder":"oY-z","account":"pY-z"};